import styled from 'styled-components';

export const IconContainer = styled.div`
  cursor: pointer;
  margin-left: 40px;
  padding-top: 8px;
  align-self: center;
`;

export default IconContainer;
